@if (initialized) {
    <div class="cn-contract-commission-container surface-0">

        <!-- Per-contract Vertragsabrechnung: the chronological commission statement lines (AP/BP/Sonstige
             badges + summary tile) are loaded and rendered by the hosted CnContractCommissionComponent
             from the bound contractId. The page shell only owns the routed skeleton, the header and the
             :contractId param resolution. -->
        <mvs-cn-contract-commission [contractId]="contractId"></mvs-cn-contract-commission>

    </div>
}
